/**
 * @generated SignedSource<<0164c2dde723ff46dcb109d217ba3d7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BillingStatus = "billed" | "unbilled" | "%future added value";
export type DashboardPageDuplicateMutation$variables = {
  id: string;
};
export type DashboardPageDuplicateMutation$data = {
  readonly duplicateTask: {
    readonly billingStatus: BillingStatus;
    readonly date: string;
    readonly durationMinutes: number;
    readonly id: string;
    readonly title: string;
    readonly totalAmount: number;
  };
};
export type DashboardPageDuplicateMutation = {
  response: DashboardPageDuplicateMutation$data;
  variables: DashboardPageDuplicateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Task",
    "kind": "LinkedField",
    "name": "duplicateTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "durationMinutes",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "billingStatus",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardPageDuplicateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardPageDuplicateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3aadcffafaf8d6049e8796c8b34a1ed6",
    "id": null,
    "metadata": {},
    "name": "DashboardPageDuplicateMutation",
    "operationKind": "mutation",
    "text": "mutation DashboardPageDuplicateMutation(\n  $id: ID!\n) {\n  duplicateTask(id: $id) {\n    id\n    title\n    date\n    durationMinutes\n    totalAmount\n    billingStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "210f09c7fa1468fbed421ca504593e3f";

export default node;
